/**
 * [Insider+] Which support UI the header shows.
 */

// The priority-support dropdown replaces the regular Support button only for
// members who have the priority_support benefit. The benefits payload carries
// the priority phone number only when that benefit is granted (empty
// otherwise), so a phone number is the signal. Anything else — benefits still
// loading, no active subscription, benefit not granted — keeps the regular
// Support button.
export const shouldShowInsiderPlusSupportDropdown = ({
  hasInsiderPlus,
  phone,
}) => !!hasInsiderPlus && !!(phone && String(phone).trim());
